export default "__VITE_ASSET__DyrbzDxg__"